export default {
  pwa: {
    installTitle: 'Install Aiiifly',
    installDescription: 'Add it to your desktop for one-click access.',
    installButton: 'Install',
    dismiss: 'Dismiss',
  },
  singleInstance: {
    title: 'Application Already Running',
    message: 'Aiiifly is already open in another window. To prevent WebHID device conflicts, only one PWA window can run at a time. Please switch to the existing window to continue.',
    closeWindow: 'Close This Window',
    hint: 'Please find the open Aiiifly window in your taskbar or window list.',
  },
  // 启动页面
  start: {
    use: 'Get Started',
    slogan: 'See it. Get it. Just a tap away.',
    tip: 'Tap "Get Started" to begin your smart experience!',
    connectHint: 'Please plug in the connector and put your device in pairing mode to connect.',
    noConnector: 'No connector detected. Please insert and try again.',
    connectorFound: 'Connector found. Just turn on your device to pair.',
    waitingDevice: 'Waiting for device to connect...',
    loadingHome: 'Loading Home...',
    deviceConnected: 'Device connected.',
    connecting: 'Connecting...',
    waitingPairing: 'Waiting for pairing',
    pairingHint: 'Please turn on your headset and wait for pairing',
    waitingUSB: 'Waiting for USB connection',
    usbHint: 'Please ensure the USB cable is properly connected',
    retry: 'Retry',
    errorDefault: 'Connection failed, please try again',
    deviceNotFound: 'Device not found, please check connection',
    permissionDenied: 'Device permission denied',
  },

  // 耳返
  sidetone: {
    label: 'Sidetone',
    volume: 'Volume',
    enabled: 'Enabled',
    disabled: 'Disabled',
  },

  // 音频混合
  audio: {
    mix: 'Mix',
    split: 'Split',
    adaptive: 'Adaptive',
    balance: 'Audio Balance',
    dongle: 'Dongle',
    bluetooth: 'Bluetooth',
    usb: 'USB',
  },

  // 通话桥接
  callBridge: {
    switchUnavailableDuringCall: 'Bridge cannot be changed during a Bluetooth call with this firmware.',
    label: 'Call Bridge',
    enabled: 'Enabled',
    disabled: 'Disabled',
    consentTitle: 'Call Bridge Feature Notice',
    consentMessage: 'Call Bridge allows seamless switching between game and call audio. Please read the following before enabling:',
    point1: 'This feature mixes game audio and call audio',
    point2: 'May affect game audio quality',
    point3: 'Recommended to enable only when needed',
    noticeTitle: 'Important Notice',
    noticeContent: 'First-time use requires audio device permission configuration. Please follow system prompts.',
    agree: 'I Understand and Agree',
    // 隐私确认弹窗（每次开启必弹）
    privacy: {
      title: 'Enable Multi-Device Bridge',
      lead: 'Route voice chat seamlessly across up to 3 connected devices (BT, 2.4G, USB).',
      onDeviceStrong: '100% On-Device Processing:',
      onDeviceText:
        'Audio is processed entirely on your local device. We never record, monitor, or upload your voice data to any cloud server.',
      consentStrong: 'Participant Consent Required:',
      consentText:
        'To protect privacy, please ensure you have explicit consent from all call participants before using Bridge.',
      ackPre: 'I acknowledge the above, agree to the ',
      termsText: 'Bridge Terms',
      ackPost: ', and confirm that I have obtained consent from all parties to enable this feature.',
      confirm: 'Confirm & Enable',
      error: 'Please read and check the agreement box to continue.',
    },
  },

  // 蓝牙分享
  btShare: {
    switchUnavailableDuringCall: 'Audio Share cannot be changed during a Bluetooth call.',
    label: 'Bluetooth Share',
    enabled: 'Enabled',
    disabled: 'Disabled',
    consentTitle: 'Bluetooth Audio Share',
    consentMessage: 'Bluetooth audio sharing allows multiple devices to listen simultaneously. Please note:',
    point1: 'Share audio to nearby Bluetooth devices',
    point2: 'May slightly increase audio latency',
    point3: 'Bluetooth connection must be active',
    noticeTitle: 'Usage Tips',
    noticeContent: 'Ensure the receiving device has Bluetooth enabled and is in pairing mode.',
    agree: 'Got it, Enable',
    // 隐私确认弹窗（每次开启必弹）
    privacy: {
      title: 'Enable Bluetooth Audio Share',
      lead: 'Relay any audio playing on this device — music, videos, and phone calls — to another paired device in real time.',
      onDeviceStrong: '100% On-Device Processing:',
      onDeviceText:
        'Audio is relayed entirely on your local devices. We never record, monitor, or upload your shared audio to any cloud server.',
      consentStrong: 'Participant Consent Required:',
      consentText:
        "If a call comes in while sharing is on, the other person's voice will be shared too. Letting others listen to a call without everyone's consent is illegal in many regions.",
      ackPre: 'I acknowledge the above, agree to the ',
      termsText: 'Audio Share Terms',
      ackPost: ', and confirm that everyone on any shared call knows and agrees.',
      confirm: 'Confirm & Enable',
      error: 'Please read and check the agreement box to continue.',
    },
  },

  // 固件升级
  upgrade: {
    title: 'Firmware Upgrade',
    currentVersion: 'Current Version',
    dongleTab: 'Dongle',
    headsetTab: 'Headset',
    bluetoothTab: 'Bluetooth',
    dongleUpgrade: 'Dongle Firmware Upgrade',
    headsetUpgrade: 'Headset Firmware Upgrade',
    bluetoothUpgrade: 'Bluetooth Firmware Upgrade',
    dongleDesc: 'Upgrade Dongle firmware for better connection stability',
    headsetDesc: 'Upgrade headset firmware for better sound quality and features',
    bluetoothDesc: 'Upgrade Bluetooth module firmware',
    step1: 'Select Firmware File',
    step2: 'Verify File',
    step3: 'Upload & Upgrade',
    step4: 'Complete',
    selectFile: 'Please select firmware file (.bin, .hex, .fw)',
    verifyFile: 'Verify firmware file information',
    upgrading: 'Upgrading, please do not disconnect...',
    waiting: 'Waiting to complete',
    success: 'Upgrade successful!',
    startUpgrade: 'Start Upgrade',
    complete: 'Complete',
    uploading: 'Uploading',
    verifying: 'Verifying',
    warning: '⚠️ Important Notice',
    warningPoint1: 'Do not disconnect device during upgrade',
    warningPoint2: 'Upgrade may take 3-5 minutes, please be patient',
    warningPoint3: 'Failed upgrade may cause device malfunction, proceed with caution',
    headsetNotice: 'Headset upgrade feature coming soon',
    bluetoothNotice: 'Bluetooth upgrade feature coming soon',
  },
  // 通用
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    loginSaveWarning: 'You are not logged in, and you will not be able to save the operation of this page',
    goToLogin: 'Go to login',
  },

  // 导航
  nav: {
    home: 'Home',
    eq: 'EQ Settings',
    rgb: 'RGB Lighting',
    noise: 'ENC',
    voice: 'Voice Effects',
    chiji: 'Gaming Mode',
    ai: 'AI Assistant',
    upgrade: 'Firmware Upgrade',
    user: 'User Center',
    settings: 'Settings',
    logout: 'Logout',
  },

  logoutConfirm: {
    title: 'Are you sure you want to log out?',
    description: 'Your account settings won’t be saved or available once you log out.',
    confirm: 'Log Out',
  },

  // RGB
  rgb: {
    title: 'RGB Lighting Settings',
    on: 'ON',
    off: 'OFF',
    selectMode: 'Select Lighting Mode',
    brightness: 'Brightness',
    connectDevice: 'Please connect device to control RGB lighting',
    modes: {
      breathing: 'Breathing',
      gradient: 'Gradient',
      chase: 'Chase',
      red: 'Red',
      blue: 'Blue',
      green: 'Green',
      purple: 'Purple',
      yellow: 'Yellow',
      cyan: 'Cyan',
      white: 'White',
    },
  },

  // 首页
  home: {
    start: 'Get Started',
    connectDevice: 'Connect Device',
    deviceNotFound: 'Device not detected, please insert and try again',
    welcome: 'Welcome to Aiiifly',
    slogan: 'See It, Hear It, Touch It',
    startHint: 'Click "Get Started" to begin your intelligent experience!',
    icp: 'ICP 2025456694',
    noDeviceConnector: 'No receiver detected. Please plug it in and try again.',
    usbIdentifyError: 'Device identification failed. Refresh the page or reconnect the device and try again.',
    waitingPairing: 'Receiver detected. Turn on the device to complete pairing.',
    connectionError: 'Connection failed. Please try again.',
    waitingUsbDevice: 'Waiting for USB device...',
    waitingDevice: 'Waiting for device...',
    scenario: {
      title: 'Scenario Presets',
      description: 'Choose a scenario to instantly apply a tuned set of audio settings.',
      gaming: 'Gaming',
      meeting: 'Meeting',
      creator: 'Creator',
      study: 'Study',
      groupCall: 'Group Call',
      music: 'Music',
      movie: 'Movie',
      listenTogether: 'Listen Together',
      expand: 'Expand scenario presets',
      collapse: 'Collapse scenario presets',
      suggestApplied: '{scene} mode is on based on your recent usage',
      suggestFailed: 'Unable to load your recommended scenario. Please try again.',
    },
  },

  // 设备
  device: {
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    battery: 'Battery',
    batteryLow: 'Low Battery',
    charging: 'Charging',
    headphone: 'Headphone',
    microphone: 'Microphone',
    usbMode: 'USB Wired Mode',
    wirelessMode: '2.4G Wireless Mode',
    unknown: 'Unknown Device',
    bluetooth: 'Bluetooth Version',
    dongleDetected: 'Dongle Detected',
    dongleRemoved: 'Dongle Removed',
    usbDetected: 'USB Detected',
    usbRemoved: 'USB Removed',
  },

  // EQ
  eq: {
    title: 'EQ Settings',
    game: 'Game',
    music: 'Music',
    movie: 'Movie',
    gameShort: 'Game',
    musicShort: 'Music',
    movieShort: 'Movie',
    enabled: 'EQ On',
    disabled: 'EQ Off',
    custom: 'Custom',
    addCustom: 'Add Custom',
    deleteConfirm: 'Are you sure you want to delete this preset?',
    deleteConfirmTitle: 'Are you sure you want to delete this tag?',
    deleteConfirmDescription: 'This action cannot be undone.',
    reset: 'Reset',
    pin: 'Pin',
    saveAs: 'Save As',
    copy: 'copy',
    saved: 'Preset saved',
    pinned: 'Preset pinned',
    resetDone: 'Preset reset',
    customLimit: 'You can save up to 20 custom presets',
    customLimitLight: "You've reached the limit of 20 custom tags.",
    nameLengthLimit: 'Tag names can be up to 20 characters.',
    nameExists: 'A preset with this name already exists',
    rename: 'Rename Preset',
    gain: 'Gain',
    frequency: 'Frequency',
  },

  // 降噪
  noise: {
    title: 'AI Noise Reduction',
    aiNoise: 'AI Noise Reduction',
    aiNoiseHeadphone: 'AI Noise Reduction',
    micNoise: 'Mic Noise Reduction',
    level: 'Reduction Level',
    levelLow: 'Low',
    levelMedium: 'Medium',
    levelHigh: 'High',
    parameterAdjustment: 'Parameter Adjustment',
    enc: 'AI ENC',
    encDesc: 'Intelligently identifies ambient noise to improve call clarity',
    aiNoiseDesc: 'Recommended during calls or recording to effectively reduce ambient noise',
  },

  // 变声效果
  voice: {
    title: 'Voice Effects',
    enabled: 'Enable Voice Change',
    boy: 'Boy',
    girl: 'Girl',
    child: 'Child',
    robot: 'Robot',
    monster: 'Monster',
    normal: 'Normal',
    preview: 'Effect Preview',
    previewHint: 'Turn on to preview voice effects in real-time',
  },

  // 固件
  firmware: {
    title: 'Firmware Upgrade',
    currentVersion: 'Current Version',
    latestVersion: 'Latest Version',
    checkUpdate: 'Check for Updates',
    startUpgrade: 'Start Upgrade',
    selectTarget: 'Select Upgrade Target',
    updating: 'Updating...',
    updateSuccess: 'Update Successful',
    updateFailed: 'Update Failed',
    releaseNotes: 'Release Notes',
    deviceReady: 'Device Ready',
    deviceLowPower: 'Low Battery',
    deviceBusy: 'Device Busy',
    historyVersions: 'History Versions',
    selectLocalFile: 'Select Local Firmware',
    manualPick: 'Select Device Manually',
    version: 'Version',
    updateDate: 'Updated',
    management: 'Firmware Management',
    device: 'Model',
    fileName: 'File Name',
    description: 'Description',
    action: 'Action',
    upgradeToLatest: 'Upgrade to Latest Version',
    upgradeLatestTooltip: 'Current version is already the latest',
    rollbackTip: 'If version rollback is needed, you can use',
    historyText: 'history version.',
    historyView: 'View',
    historyHide: 'Hide',
    upgradeToThisVersion: 'Upgrade to this version',
    confirmUpgradeTitle: 'Are you sure you want to upgrade to this version?',
    confirmUpgradeDesc: 'After confirmation, the system will complete the entire upgrade process. The process cannot be interrupted. Please keep the device powered and stably connected.',
    preparingUpgrade: 'Preparing upgrade...',
    preparing: 'Preparing...',
    detectingDevice: 'Detecting device...',
    reconnectingDevice: 'Reconnecting device...',
    downloadingFirmware: 'Downloading firmware...',
    sendingEnterUpgrade: 'Sending enter-upgrade command...',
    waitingUpgradeDevice: 'Command sent. Waiting for upgrade-mode device...',
    transferringFirmware: 'Transferring firmware data...',
    upgradingTitle: 'Upgrading [{device}]. Do not disconnect.',
    upgradeCompleteTitle: 'Upgrade complete [{device}]',
    upgradeFailedTitle: 'Upgrade failed [{device}]',
    upgradeComplete: 'Upgrade complete!',
    upgradeFailed: 'Upgrade failed',
    upgradeWarning: 'Upgrading. Please do not close this page or disconnect.',
    failedChoosePrefix: 'Upgrade failed, you can choose another ',
    historyVersion: 'history version',
    deviceNotFoundPlease: 'Device not found. Please ',
    selectManually: 'select manually',
    noVersions: 'No versions',
    noDeviceSelected: 'No device selected',
    unknownDevice: 'Unknown',
    deviceNotFound: 'Device not found',
    deviceInfo: 'Device: {name} (VID:0x{vid} PID:0x{pid})',
    failedSelectHistory: 'Upgrade failed. Select a history version to continue.',
    versionBeforeUpgrade: 'Version before upgrade',
    upgradeSuccessToast: 'Upgrade successful, experience updated!',
    connectionTypeUsb: 'USB wired',
    connectionTypeDongle: '2.4G wireless dongle',
    connectionTypeUnknown: 'unknown connection type',
    connectionTypeMismatch: 'The current connection type does not meet the upgrade requirement for [{device}]. Please switch to {required} and try again.',
    connectionTypeMismatchUsbTooltip: 'Please connect with USB and headset',
    connectionTypeMismatchDongleTooltip: 'Please use a 2.4G connection',
    connectionTypeMismatchStatus: 'Current connection type is {actual}, but upgrading [{device}] requires {required}.',
    connectionTypeUnknownStatus: 'Unable to detect the current connection type. Please reconnect the correct device and try again.',
    descriptions: {
      earphone: {
        latest: 'Optimized audio EQ for richer bass and clearer treble.',
        V1_1_2: 'Optimized audio EQ.',
        V1_1_1: 'Fixed static noise.',
      },
      earphoneBluetooth: {
        latest: 'Enhanced Bluetooth connection stability.',
        V1_1_3: 'Enhanced Bluetooth connection stability.',
        V1_1_2: 'Enhanced Bluetooth stability.',
        V1_1_1: 'Enhanced Bluetooth stability.',
      },
      earphoneNoiseCancel: {
        latest: 'Upgraded wind-noise reduction algorithm.',
        V1_1_2: 'Advanced noise cancellation.',
      },
      dongle: {
        latest: 'Resolved USB 3.0 compatibility issues.',
        V1_1_2: 'Fixed stability issues.',
      },
    },
    tabs: {
      earphone: 'Headset',
      earphoneBluetooth: 'Bluetooth',
      earphoneNoiseCancel: 'AI ENC&ENC',
      dongle: 'Dongle',
    },
  },

  // 用户中心
  user: {
    profile: 'Profile',
    profileNav: 'Profile',
    account: 'Account',
    passwordNav: 'Password',
    upgrade: 'Upgrade',
    accountSettings: 'Account Settings',
    passwordSettings: 'Password Settings',
    // 个人资料页
    nickname: 'Username',
    inputNickname: 'Enter',
    changeAvatar: 'Change Avatar',
    saveChanges: 'Save Changes',
    avatarEditorCancel: 'Cancel',
    avatarEditorSave: 'Save',
    // 账号设置
    linkAccount: 'Link Account',
    linkPhone: 'Link Phone Number',
    inputPhone: 'Enter New',
    phoneNext: 'Next',
    phoneChange: 'Change',
    linkEmail: 'Link Email',
    inputEmail: 'Enter',
    emailNext: 'Next',
    emailChange: 'Change',
    linkThirdParty: 'Link Third-Party Account',
    linkThirdPartyDesc: 'Link a third-party account to log in to Aiiifly easily and sync your content to the platforms below to share with more friends.',
    googleLink: 'Link',
    appleLink: 'Link',
    wechatLink: 'Link',
    verificationCode: 'Verification Code',
    inputVerCode: 'Enter verification code',
    getCode: 'Get Code',
    sendCode: 'Send Code',
    resend: 'Resend in {sec}s',
    verifyNext: 'Next',
    phoneConfirm: 'Confirm Phone Number',
    emailConfirm: 'Confirm Link',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'Deleting your account will permanently erase all data and cannot be undone. Please proceed with caution.',
    deleteAccountBtn: 'Delete Account',
    deleteDialogTitle: 'Are you sure you want to deactivate your account?',
    deleteDialogDesc: 'All data associated with this account will be permanently deleted and cannot be recovered. Please proceed with caution.',
    deleteDialogCancel: 'Cancel',
    deleteDialogConfirm: 'Confirm Account Deletion',
    // 密码设置
    pwdAccount: 'Account',
    pwdInputAccount: 'Enter phone or email',
    pwdAccountHint: 'Enter your current login phone or email',
    pwdNext: 'Next',
    pwdVerificationCode: 'Verification Code',
    pwdVerifyCode: 'Verification Code',
    pwdInputVerCode: 'Enter verification code',
    pwdGetCode: 'Get Code',
    pwdSendCode: 'Send Code',
    pwdVerifyNext: 'Next',
    pwdNewPassword: 'New Password',
    pwdInputNew: 'Enter new password',
    pwdConfirmPassword: 'Confirm New Password',
    pwdInputConfirm: 'Re-enter new password',
    pwdChangePassword: 'Change Password',
    pwdConfirmBtn: 'Change Password',
    pwdThirdPartyWarning: 'You are logged in via a third-party account. Please bind a phone number or email in Account Settings before setting a password.',
    pwdFormatHint: '6+ characters. Letters, numbers, and common keyboard symbols only',
    pwdSave: 'Save',
    pwdVerifyInstruction: 'Please enter the 6-digit verification code we sent to',
    pwdVerifyTitle: 'Enter verification code',
    pwdResend: 'Resend Code',
    pwdResendIn: 'Resend in {sec}s',
    pwdOr: 'or',
    pwdChangeEmail: 'Change Email',
    noEmailLinkedTitle: 'No email linked',
    noEmailLinkedDesc: "You'll need to link an email before you can sign in with this password.",
    // 提示
    tipUsernameEmpty: 'Username cannot be empty.',
    tipUsernameSuccess: 'Username updated successfully.',
    tipAvatarSuccess: 'Avatar updated successfully.',
    tipAvatarFail: 'Avatar processing failed.',
    tipSelectImage: 'Please select an image file.',
    tipEnterPhone: 'Please enter phone number',
    tipInvalidPhone: 'Please enter a valid phone number',
    tipEnterEmail: 'Please enter email',
    tipInvalidEmail: 'Please enter a valid email',
    tipEnterCode: 'Please enter 6-digit verification code',
    tipCodeSent: 'Verification code sent',
    tipPhoneBound: 'Phone bound successfully',
    tipEmailBound: 'Email bound successfully',
    tipBindFailed: 'Binding failed, please try again',
    tipOnlyAuth: 'Current account is the only authentication method and cannot be changed',
    tipVerifyPassed: 'Verification passed, please bind new account',
    tipGoogleBound: 'Google account bound successfully',
    tipAppleBound: 'Apple account bound successfully',
    tipWechatBound: 'WeChat account bound successfully',
    tipAllowPopup: 'Please allow popups to complete binding',
    tipDeleteSuccess: 'Account deleted successfully',
    tipEnterPhoneEmail: 'Please enter phone number or email',
    tipInvalidPhoneEmail: 'Please enter a valid phone number or email',
    tipAccountNotLinked: 'This account is not linked. You can only change the password for your current login account.',
    tipPwdFormat: 'Password must be at least 6 characters and use letters, numbers, and common symbols only',
    tipPwdMismatch: 'Passwords do not match.',
    tipPwdSuccess: 'Password changed successfully.',
    tipCodeSentSuccess: 'Verification code sent',
    tipEnter6Code: 'Please enter 6-digit verification code',
    tipIncorrectCode: 'Incorrect verification code.',
    tipPasswordUpdated: 'Password updated successfully.',
    // 其他
    email: 'Email',
    phone: 'Phone',
    avatar: 'Avatar',
    password: 'Password',
    changePassword: 'Change Password',
    saveSuccess: 'Saved Successfully',
  },

  // 认证
  auth: {
    login: 'Login',
    register: 'Sign Up',
    forgotPassword: 'Forgot Password',
    email: 'Email',
    phone: 'Phone Number',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    verificationCode: 'Verification Code',
    getCode: 'Get Code',
    loginSuccess: 'Login Successful',
    registerSuccess: 'Registration Successful',
    passwordMismatch: 'Passwords do not match',
    username: 'Username',
    rememberMe: 'Remember Me',
    noAccount: "Don't have an account?",
    registerNow: 'Register Now',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    agreeTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    authType: 'Auth Type',
    // 登录页
    headerTitle: 'Welcome to your account',
    googleLogin: 'Google',
    appleLogin: 'Apple ID',
    wechatLogin: 'WeChat',
    moreLoginMethods: 'More Login Methods',
    middleTitle: 'Email Sign in',
    phoneOrEmail: 'Email',
    inputPhoneOrEmail: 'Please enter',
    inputEmail: 'Please enter your email',
    inputPassword: 'Please enter your password',
    passwordLoginBtn: 'Password Login',
    codeLoginBtn: 'Verification Code Login',
    passwordTips: 'Please confirm that you have set a password.',
    sendCodeBtn: 'Send Verification Code',
    loginBtn: 'Login',
    securityText: 'I agree to the',
    userAgreement: 'Terms of Use',
    privacyAgreement: 'Privacy Policy',
    agreementModalTitle: 'Aiiifly Terms of Service and Privacy Policy Notice',
    agreementModalLead: 'Thank you for using the Aiiifly web driver! Before logging in and connecting your headset device, please read carefully and fully understand our',
    agreementModalAnd: 'and',
    agreementModalPeriod: '.',
    agreementModalData: "To provide core features like device recognition, AI noise cancellation, and EQ cloud backups, we need to collect basic device identifiers and operation logs. By checking the box and clicking 'Agree and Continue', you consent to this data usage.",
    agreementDecline: 'Decline and Exit',
    agreementConfirm: 'Agree and Continue',
    // 验证页
    checkPhone: 'Check SMS to Your Phone',
    checkEmail: 'Check your email',
    verifyInstruction: 'Please enter the 6-digit verification code we sent to',
    verifySuffix: '.',
    verifyBtn: 'Verify',
    resendCode: 'Resend Code',
    resendCodeCountdown: '{sec} s Resend Code',
    // 提示
    tipEnterAccount: 'Please enter your email',
    tipInvalidAccount: 'Please enter a valid email',
    tipPasswordFormat: 'Password must be 8-16 characters and contain letters and numbers',
    tipWaitResend: 'Please wait {sec} seconds before resending',
    tipCodeFailed: 'Failed to get verification code',
    tipEnterCode: 'Please enter a 6-digit verification code',
    tipVerifyFailed: 'Verification code error',
    tipLoginFailed: 'Login failed',
    tipResendFailed: 'Failed to resend',
    tipThirdPartyFailed: 'Failed to get login URL',
    loading: 'Please wait...',
    verifying: 'Verifying...',
  },

  // 一键吃鸡（游戏模式）
  chiji: {
    title: 'Positioning',
    footsteps: 'Footsteps',
    gunfire: 'Gunshots',
    enabled: 'Enable Positioning',
    presets: 'Presets',
    addPreset: 'Add Preset',
    deletePreset: 'Delete Preset',
    deleteConfirm: 'Are you sure you want to delete preset "{name}"?',
    presetNamePlaceholder: 'Enter preset name',
    gunSound: 'Gun Sound Enhancement',
    footstep: 'Footstep Enhancement',
    gunHint: 'Enhance low-frequency gun sounds for better shooting feedback',
    footstepHint: 'Enhance high-frequency footsteps for better positioning',
    reset: 'Reset',
    description: 'Positioning enhances gun sounds and footsteps through EQ adjustment. Low frequencies (20-1000Hz) optimize gun sounds, high frequencies (2000-16000Hz) optimize footsteps.',
  },

  // AI 助手
  aiAssistant: {
    title: 'AI Assistant',
    enabled: 'Enable Voice Control',
    disabled: 'Voice Control Disabled',
    tapToSpeak: 'Tap microphone to start voice control',
    listening: 'Listening...',
    quickCommands: 'Quick Commands',
    showHistory: 'View History',
    hideHistory: 'Hide History',
    noHistory: 'No voice records yet',
    clearHistory: 'Clear History',
    categoryEq: 'EQ Mode',
    categoryChiji: 'Gaming Mode',
    categoryVoice: 'Voice Effects',
    categoryDevice: 'Device',
    categorySystem: 'System',
    helpTitle: 'Usage Tips:',
    help1: 'Tap the microphone button and speak commands',
    help2: 'Supported: "Switch to game mode", "Enable gaming", "Mute", etc.',
    help3: 'Or tap quick commands below to execute directly',
    browserWarning: 'Your browser does not support speech recognition. Please use Chrome or Edge.',
    commandSuccess: 'Command executed successfully',
    commandFailed: 'Command execution failed',
  },

  // 顶部栏
  header: {
    battery: 'Battery',
    usbMode: 'USB',
    wirelessMode: '2.4G',
    language: 'Language',
    hotkey: 'Hotkeys',
    theme: {
      dark: 'Dark',
      light: 'Light',
      system: 'System',
    },
    userCenter: 'User Center',
    firmwareUpgrade: 'Upgrade',
    preferences: 'Preferences',
    about: 'About',
    aboutUs: 'About Us',
  },

  hotkey: {
    dialogTitle: 'Hotkey Settings',
    notSet: 'Not Set',
    conflict: 'Hotkey conflict: already used by',
    conflictUsed: 'Used',
    switched: 'Switched',
    powerToggle: 'Power Toggle',
    eqToggle: 'EQ Toggle',
    rgbToggle: 'RGB Toggle',
    aiToggle: 'AI ENC',
    balenceToggle: 'Audio Mode',
    Positioning: 'Positioning',
    tip: 'Click input box and press keys',
    reset: 'Reset',
    occupied: 'Hotkey is occupied',
  },

  // 底部栏
  footer: {
    eq: 'EQ',
    rgb: 'RGB',
    voice: 'Voice',
    mute: 'Mute',
    micMute: 'Mic Mute',
    kangganrao: 'Anti-Interference',
    chiji: 'Positioning',
    ai: 'AI Assistant',
    level: 'Level',
    audioMix: 'Audio Mix',
    audioSplit: 'Audio Split',
    comingSoon: 'Coming Soon',
    off: 'OFF',
  },

  // 主菜单（底部菜单）
  main: {
    chickenDinner: 'Positioning',
  },

  // 主菜单 RGB（底部菜单 RGB 模式）
  mainrgb: {
    numberedMode: 'Mode {mode}',
    breathing: 'Purple Rhythm',
    gradient: 'Cyan Rhythm',
    marquee: 'Blue Rhythm',
    mic_gradient: 'Spectrum',
    mic_breathing: 'Breathing',
    red: 'Red',
    blue: 'Blue',
    green: 'Green',
    purple: 'Purple',
    yellow: 'Yellow',
    cyan: 'Cyan',
    white: 'White',
  },
} as const
